// import axiosInstance from "utils/AxiosInstance";
import axiosInstance from "../utils/AxiosInstance";
const BASE_URL = process.env.REACT_APP_BASE_URL;

//APPLICATION API STARTS HERE
export const listApplications = async (appId) => {
  try {
    let endpoint = `${BASE_URL}/application`;
    if (appId) {
      endpoint = `${BASE_URL}/application/${appId}`;
    }
    const response = await axiosInstance.get(`${endpoint}`);
    if (response.status === 200) {
      return response.data;
    } else {
      const errorData = response.data;
      throw new Error(errorData.message || "Unable to fetch application");
    }
  } catch (error) {
    throw error;
  }
};

export const createApplication = async (appPayload) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/application/new/`,
      appPayload
    );
    if (response.status === 201) {
      return response.data;
    } else {
      const errorData = response.data;
      throw new Error(errorData.message || "Unable to create application");
    }
  } catch (error) {
    console.error("Application creation Failed:", error);
    throw error;
  }
};

export const updateApplication = async (appId, payload) => {
  try {
    const response = await axiosInstance.patch(
      `${BASE_URL}/application/${appId}`,
      payload
    );
    if (response.status !== 200) {
      throw new Error("Application updation Faild !");
    }
    return response.data;
  } catch (error) {
    console.error("Application updation Faild :", error);
    throw error;
  }
};

export const fetchApplications = async (appId) => {
  try {
    if (appId) {
      const response = await axiosInstance.get(
        `${BASE_URL}/application/${appId}`
      );
      return response.data;
    } else {
      const response = await axiosInstance.get(`${BASE_URL}/application/`);
      return response.data;
    }
  } catch (error) {
    console.error("Application fetch Faild :", error);
    throw error;
  }
};

export const deleteApplication = async (appId) => {
  try {
    const endpoint = `${BASE_URL}/application/${appId}`;
    const response = await axiosInstance.delete(endpoint);
    const data = await response.data;
    return data;
  } catch (error) {
    console.error("Application delete Failed :", error);
    throw error;
  }
};

//APPLICATION API ENDS HERE
